import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { RafflesFacade } from '@galabid/gb-dashboard/raffle/data-access'
import { TranslateModule } from '@ngx-translate/core'
import { ItemsEntity } from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.models'
import { GbPresenterToolsAdvancedOptionsContainerComponent } from 'libs/gb-dashboard/presenter/feature/src/lib/gb-presenter-tools-advanced-options-container/gb-presenter-tools-advanced-options-container.component'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { Observable } from 'rxjs'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'

@Component({
  selector: 'gb-presenter-tools-raffle-winners-list',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    GbPresenterToolsTextComponent,
    GbPresenterToolsAdvancedOptionsContainerComponent,
  ],
  templateUrl: './gb-presenter-tools-raffle-winners-list.component.html',
  styleUrl: './gb-presenter-tools-raffle-winners-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsRaffleWinnersListComponent {
  private rafflesFacade = inject(RafflesFacade)

  @Input({ required: true }) toolsFormGroup!: FormGroup
  @Input() editMode = false
  @Input() prizesAvailable: number | null = null
  @Input() isTemplateMode = false

  @Output() preview = new EventEmitter<void>()
  @Output() resetPreview = new EventEmitter<void>()

  hideFields = ['font_style', 'color']

  raffleItems$: Observable<ItemsEntity[]> = this.rafflesFacade.allRaffleItems$
  raffleItemsLoaded$ = this.rafflesFacade.loaded$

  get itemControl(): FormControl {
    return this.toolsFormGroup.get('raffle_item') as FormControl
  }

  get primaryColorControl(): FormControl {
    return this.toolsFormGroup.get('primary_color') as FormControl
  }

  get accentColorControl(): FormControl {
    return this.toolsFormGroup.get('accent_color') as FormControl
  }

  get rowsControl(): FormControl {
    return this.toolsFormGroup.get('rows') as FormControl
  }

  get columnsControl(): FormControl {
    return this.toolsFormGroup.get('columns') as FormControl
  }

  previewDraw(): void {
    this.preview.emit()
  }

  resetPreviewDraw(): void {
    this.resetPreview.emit()
  }

  compareItemsByUuid(a: ItemsEntity | null, b: ItemsEntity | null): boolean {
    return a?.uuid === b?.uuid
  }
}
